<template>
    <div class="lawyer_list" v-loading="loading">
        <div class="lawyer_list_box">
             <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <span class="span1">首页</span> > <span class="span2">法律咨询 > 预约律师</span>
             </div>
             <div class="check_box">
                <div class="check_felx">
                    <div class="check_title">区域省份</div>
                    <div class="check_list" :class="{'check_list_minh':sf_show,'check_list_maxh':!sf_show}">
                        <div class="check_item" :class="{check_ac:sf_ac.id==item.id}" v-for="(item,index) in sf_list" :key="index" @click="handle_sf_ac(item)">{{ item.name }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':sf_show}" @click="handle_sf_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">擅长领域</div>
                    <div class="check_list" :class="{'check_list_minh':sc_show,'check_list_maxh':!sc_show}">
                        <div class="check_item"  :class="{check_ac:sc_ac.id==item.id}" v-for="(item,index) in sc_list" :key="index" @click="handle_sc_ac(item)">{{ item.title }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':sc_show}" @click="handle_sc_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>

                <div class="check_felx">
                    <div class="check_title">已选择</div>
                    <div class="check_ac_flex">
                        <div class="check_ac_box" v-if="sf_ac.id">
                            {{ sf_ac.name }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('sf_ac')">
                        </div>
                        <div class="check_ac_box" v-if="sc_ac.id">
                            {{ sc_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('sc_ac')">
                        </div>
                        <!-- <div class="check_ac_text"></div> -->
                        <div class="chack_ac_clear" @click="handle_qk">清空</div>
                    </div>
                </div>
             </div>
             <div class="list_box">
                <div class="list_item" v-for="(item,index) in list" :key="index" @click="handle_info(item)">
                    <div class="item_tops">
                        <div class="imgs">
                            <!-- <img src="../../../assets/img/index/legal/user_img.png" alt=""> -->
                             <img :src="item.business_img" alt="">
                        </div>
                        <div class="info_box">
                            <div class="titles">
                                <div class="names">
                                    {{ item.name }}
                                    <img src="../../../assets/img/index/legal/vips.png" alt="">
                                </div>
                                <div class="btns">咨询我</div>
                                <!--  @click.stop="handle_check(item)" -->
                            </div>
                            <div class="address">{{ item.work_company }}</div>
                            <div class="introduce">
                                <!-- 婚姻家庭，立案问题，刑事犯罪，刑事侦查， 刑事辩护 -->
                            {{ get_cause_title(item.causeIds||'') }}

                            </div>
                        </div>
                    </div>
                    <div class="item_boms">
                        <div class="text_flex">
                            <div class="texts">案件数量：</div>
                            <div class="nums">{{ item.order_num }}</div>
                        </div>
                        <div class="text_flex">
                            <div class="texts">好评率：</div>
                            <div class="nums">{{ item.good_lv }}</div>
                        </div>
                        <div class="text_flex">
                            <div class="texts">评价数：</div>
                            <div class="nums">{{ item.comment_num }}</div>
                        </div>
                    </div>
                </div>
             </div>
             <div class="pages_box">
                <div class="btns" @click="handle_pages(1)">首页</div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    background
                    :page-size="pages.limit"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
                <div class="btns"  @click="handle_pages(last_page)">尾页</div>
             </div>
           
        </div>
        <online_check ref="online_check"  @handle_end="handle_end"></online_check>

    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import online_check from '@/components/legal_advice/online_check.vue'//提交成功



export default {
    components: {
        online_check
        
    },
    name: "homes",
    data() {
        return {
            loading:false,
            sf_list:[],//省份列表
            sf_ac:{},//省份的选中
            sf_show:false,//省份的显示隐藏

            sc_list:[],//擅长领域
            sc_ac:{},//擅长领域的选中
            sc_show:false,//擅长领域的显示隐藏
            list:[],
            total:0,
            last_page:0,
            pages:{
                page:1,
                limit:15,
            },
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_sf_list()
        this.get_list()
        this.get_sc_list()
    },
    methods: {
        handle_sf_show(){
            this.sf_show=!this.sf_show
        },
        handle_sc_show(){
            this.sc_show=!this.sc_show
        },
        handleSizeChange(e){
            console.log('条数',e)            
        },
        handleCurrentChange(e){
            console.log('页数',e)
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
        },
        //跳转详情
        handle_info(item){
            this.$router.push({
                path:'/lawyer_detial',
                query:{
                    id:item.id,
                    user_id:item.user_id,
                },
            })
        },
        //咨询
        handle_check(item){
            this.$refs.online_check.handle_open()
        },
        handle_end(){
            console.log('回调')
        },
        //省份选择
        handle_sf_ac(item){
            this.sf_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_sc_ac(item){
            this.sc_ac=item
            this.pages.page=1
            this.get_list()
        },
        ac_clear(text){
            this[text]={}
            this.pages.page=1
            this.get_list()
        },
        handle_qk(){
            this.sf_ac={}
            this.sc_ac={}
            this.pages.page=1
            this.get_list()
        },
        get_list(){
            this.loading = true
            this.$api("lawyers", {
                ...this.pages,
                province:this.sf_ac.id||"",
                causeIds:this.sc_ac.id||"",
			}, "get").then((res) => {
                this.loading = false
                console.log('律师列表',res)
                if (res.code == 1) {
                    this.list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },

        get_sf_list(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.sf_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_sc_list(){
            this.$api("cause", {
                
				// type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.sc_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_cause_title(ids){
            let text=''
            let text_list=[]
            let id_list=[]
            if(ids){
                id_list=ids.split(',')
            }
            this.sc_list.forEach((e)=>{
                id_list.forEach((v)=>{
                    if(e.id==v){
                        text_list.push(e.title)
                    }
                })
            })
            text=text_list.join(',')
            return text
        },
    },

}
</script>
<style scoped lang="less">
.lawyer_list{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .lawyer_list_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_ac{
                        color: #377CFD;

                    }
                }
                .check_list_maxh{
                    height: 60px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 60px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }
            }
        }
        .list_box{
            display: flex;
            flex-wrap: wrap;
            padding-top: 24px;
            .list_item{
                width: 464px;
                height: 240px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                margin-right: 24px;
                margin-bottom: 24px;
                // padding: 32px 30px;
                padding: 32px 30px 18px 30px;
                &:nth-child(3n){
                    margin-right: 0;
                }
                .item_tops{
                    display: flex;
                    // height: 200px;
                    padding-bottom: 36px;
                    border-bottom:  1px solid #E8E8E8;
                    flex-shrink: 0;

                    .imgs{
                        width: 90px;
                        height: 90px;
                        flex-shrink: 0;
                        cursor: pointer;

                        img{
                            width: 90px;
                            height: 90px;
                        }
                    }
                }
                .info_box{
                    width: 100%;
                    padding-left: 30px;
                    .titles{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .names{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                            cursor: pointer;
                            img{
                                width: 20px;
                                height: 20px;
                                margin-left: 8px;
                            }
                        }
                        .btns{
                            width: 92px;
                            height: 32px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;
                            text-align: center;
                            line-height: 32px;
                        }
                    }
                    .address{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        padding-top: 4px;
                    }
                    .introduce{
                        padding-top: 18px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }
                }
                .item_boms{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 18px;
                    .text_flex{
                        display: flex;
                        align-items: center;
                        .texts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #666666;
                        }
                        .nums{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;
                        }
                    }

                }
            }
        }
        .pages_box{
            width: 100%;
            height: 100px;
            // background-color: red;
            display: flex;
            align-items: center;
            justify-content: center;
            /deep/.el-pagination{
                .el-pager{
                    .number {
                        background-color: #FFFFFF;
                    }
                    .active{
                        background-color: #377CFD;
                    }
                }
            }
            .btns{
                width: 40px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #EEEEEE;  
                font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                font-weight: normal;
                font-size: 14px;
                color: #7A7A7A;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }
        }
         
        
        
    }
    
}

</style>